import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {DmsDataGrid} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface DeliveriesSegmentProps extends RequiredTestIdProps {
  orderItemId: string | Nullish;
}

export function DeliveriesSegment(props: DeliveriesSegmentProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {orderItemId: props.orderItemId}]),
    [props.orderItemId]
  );

  return (
    <DmsDataGrid
      gridCode="warehouse-supplier-order-item-deliveries"
      queryModifier={queryModifier}
      autoHeight
      data-testid={suffixTestId('requests', props)}
    />
  );
}
